import './globals.js';
import './sites/about--contact.js';
import './sites/about.js';
import './sites/imprint.js';
import './sites/projects--entry.js';
import './sites/projects.js';
import './startAnimation.js';
import './eventHandler.js';

const isTouchDevice = 'ontouchstart' in document.documentElement;

if (!isTouchDevice) {
	BODY_ELEMENT.classList.add('no-touch');
}
